export default __webpack_public_path__ + "static/media/G_D_btn__Magento_Roll.a8d02621.svg";